import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Stack,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircle, Error } from '@mui/icons-material';
import { ApiHelper } from '../utils/apiHelper';
import { toast } from 'react-toastify';

const CommitteeValidationPage = () => {
  const { sentToken, status } = useParams();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [validationResult, setValidationResult] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await ApiHelper.get(`/admin/validate-committee-token/${sentToken}/${status}`);
        setValidationResult({
          success: response.data.code === '00000',
          message: response.data.message
        });
      } catch (error) {
        console.error('Token validation error:', error);
        setValidationResult({
          success: false,
          message: error.response?.data?.message || 'Doğrulama işlemi sırasında bir hata oluştu'
        });
      } finally {
        setLoading(false);
        setOpenModal(true);
      }
    };

    if (sentToken && status) {
      validateToken();
    } else {
      setLoading(false);
      setValidationResult({
        success: false,
        message: 'Geçersiz doğrulama linki'
      });
      setOpenModal(true);
    }
  }, [sentToken, status]);

  const handleClose = () => {
    setOpenModal(false);
    navigate('/');
  };

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <>
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" align="center" color="text.secondary">
            Doğrulama işlemi gerçekleştiriliyor...
          </Typography>
        </Box>
      </Container>

      <Dialog
        open={openModal}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ pb: 0 }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            {validationResult?.success ? (
              <CheckCircle color="success" sx={{ fontSize: 28 }} />
            ) : (
              <Error color="error" sx={{ fontSize: 28 }} />
            )}
            <Typography variant="h6">
              {validationResult?.success ? 'Doğrulama Başarılı' : 'Doğrulama Başarısız'}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          {validationResult?.success ? (
            <Box sx={{ py: 2 }}>
              <Typography paragraph>
                Komite değerlendirmeniz başarıyla kaydedildi. Değerlendirme sürecine katkınız için teşekkür ederiz.
              </Typography>
              <Typography color="text.secondary">
                Bu pencereyi kapatabilirsiniz. Değerlendirme sonucu ilgili birimlere iletilmiştir.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ py: 2 }}>
              <Typography color="error" paragraph>
                {validationResult?.message}
              </Typography>
              <Typography color="text.secondary">
                Eğer bu bir hata olduğunu düşünüyorsanız, lütfen sistem yöneticisi ile iletişime geçin.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button
            variant="contained"
            onClick={handleClose}
            color={validationResult?.success ? 'success' : 'primary'}
            fullWidth
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CommitteeValidationPage; 